import { render, staticRenderFns } from "./Suptoserve.vue?vue&type=template&id=3d576484&scoped=true"
import script from "./Suptoserve.vue?vue&type=script&lang=js"
export * from "./Suptoserve.vue?vue&type=script&lang=js"
import style0 from "./Suptoserve.vue?vue&type=style&index=0&id=3d576484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d576484",
  null
  
)

export default component.exports